import VistoriaAberturaView from "../../components/estoque/VistoriaAberturaView";

export default function VistoriaAbertura() {
  return <VistoriaAberturaView />;
}
